import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useModules } from "@/lib/useModules";
import { AppTopBar } from "@/components/AppTopBar";

export default function OrderList() {
  const { user } = useAuth();
  const { can: canModule, ready: modReady } = useModules();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/orders")
      .then(({ data }) => setOrders(data))
      .catch((err) => setError(formatApiErrorDetail(err.response?.data?.detail) || err.message));
  }, []);

  if (modReady && !canModule("ORDER_GINEE")) {
    return (
      <div className="app-shell">
        <AppTopBar active="orders" />
        <main className="content"><div className="alert-error" data-testid="access-denied">Akses ditolak.</div></main>
      </div>
    );
  }

  return (
    <div className="app-shell">
      <AppTopBar active="orders" />
      <main className="content">
        {error && <div className="alert-error" data-testid="error-banner">{error}</div>}
        <section className="panel" data-testid="order-list-panel">
          <div className="panel-head">
            <h2 className="panel-title">Daftar Order ({orders.length})</h2>
            <div style={{ display: "flex", gap: 8 }}>
              <Link to="/imports" className="btn-primary inline" data-testid="goto-imports">Riwayat Import & Picking</Link>
              <Link to="/orders" className="btn-primary inline" data-testid="goto-import">+ Import Ginee</Link>
            </div>
          </div>
          <div className="table-scroll">
            <table className="data-table" data-testid="order-table">
              <thead>
                <tr>
                  <th>ID Pesanan</th>
                  <th>Nama Toko</th>
                  <th>Waktu Pembayaran</th>
                  <th>Kurir</th>
                  <th>AWB</th>
                  <th>SKU</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {orders.length === 0 && (
                  <tr><td colSpan={7} className="empty-cell">Belum ada order. Import file Ginee terlebih dahulu.</td></tr>
                )}
                {orders.map((o) => (
                  <tr key={o.id} onClick={() => navigate(`/orders/${o.id}`)} style={{ cursor: "pointer" }} data-testid={`order-row-${o.source_order_id}`}>
                    <td className="mono">{o.source_order_id}</td>
                    <td>{o.store_name || "-"}{!o.store_resolved && <span className="tag-warn" data-testid={`unresolved-store-${o.source_order_id}`}>UNRESOLVED</span>}</td>
                    <td>{o.payment_time || "-"}</td>
                    <td>{o.courier || "-"}</td>
                    <td className="mono">{o.tracking_no || "-"}</td>
                    <td>{o.item_count}</td>
                    <td>
                      <span className="status-pill on">{o.operational_status}</span>
                      {o.cancellation_status !== "NONE" && <span className="tag-warn" data-testid={`cancel-flag-${o.source_order_id}`}>{o.cancellation_status}</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </div>
  );
}
